module.exports = __webpack_public_path__ + "img/home-eq.96721da3.png";